function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_346_650)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 60,
  fill: "white",
  className: "backgroundFill"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M30.6267 81.851C30.6267 81.3483 30.6551 80.8456 30.6267 80.3486C30.6267 79.9984 30.4789 79.6595 30.2289 79.4053C29.9788 79.1568 29.6435 79.0099 29.2855 78.9986C28.5296 78.9986 27.9386 79.3658 27.8363 80.1226C27.6658 81.2806 27.6658 82.4554 27.8363 83.6133C27.95 84.3702 28.6319 84.7938 29.3935 84.6922C30.155 84.5905 30.5926 84.1217 30.6323 83.3422C30.6551 82.8508 30.6323 82.3481 30.6323 81.8454L30.6267 81.851Z",
  fill: "#273950"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M24.8472 87.5672C25.3814 87.5672 25.9156 87.601 26.4441 87.5672C26.7851 87.5502 27.1033 87.4146 27.3477 87.1774C27.5864 86.9402 27.7284 86.6182 27.7455 86.285C27.7966 85.5281 27.359 84.8842 26.5862 84.7882C25.4439 84.647 24.2902 84.6526 23.1536 84.7995C22.3864 84.9068 22 85.4716 22 86.2172C22 86.5674 22.1478 86.9063 22.3978 87.1605C22.6479 87.4146 22.9832 87.5559 23.3412 87.5672C23.8413 87.6067 24.3528 87.5672 24.8529 87.5672H24.8472Z",
  fill: "#273950"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M33.542 87.5672C34.0762 87.5672 34.6161 87.6067 35.1503 87.5559C35.4799 87.5502 35.7924 87.4147 36.0254 87.1831C36.2584 86.9515 36.3891 86.6352 36.3948 86.3076C36.463 85.5394 36.1164 84.9407 35.3435 84.8108C34.1444 84.6131 32.9225 84.6131 31.7234 84.8108C30.9846 84.935 30.6493 85.5112 30.6493 86.2172C30.6493 86.5561 30.7857 86.8837 31.0244 87.1322C31.2631 87.3808 31.5814 87.5276 31.928 87.5502C32.4679 87.5954 33.0078 87.5672 33.542 87.5672V87.5672Z",
  fill: "#273950"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M30.6268 90.4535C30.6268 89.9508 30.6496 89.4425 30.6268 88.9398C30.5814 88.149 30.1097 87.7197 29.3482 87.6124C29.0072 87.5559 28.6605 87.6406 28.3764 87.8383C28.0979 88.036 27.9047 88.341 27.8479 88.6799C27.649 89.8717 27.649 91.0805 27.8479 92.2723C27.8933 92.5265 28.0127 92.758 28.1945 92.9388C28.3764 93.1252 28.6037 93.2494 28.8594 93.3003C29.0242 93.3342 29.2004 93.3342 29.3652 93.3003C30.1324 93.193 30.5757 92.7467 30.6268 91.956C30.6553 91.4589 30.6268 90.9506 30.6268 90.4535V90.4535Z",
  fill: "#273950"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M102.7 41.7773C102.7 41.9298 102.739 42.0766 102.802 42.2122C103.62 43.404 104.66 44.432 105.871 45.234C106.445 45.6012 107.053 45.3244 107.473 44.833C107.934 44.3021 108.025 43.6469 107.559 43.1159C106.74 42.2065 105.876 41.348 104.961 40.5346C104.541 40.1505 103.961 40.1562 103.438 40.4668C103.205 40.5968 103.012 40.7888 102.881 41.0204C102.751 41.252 102.694 41.5174 102.711 41.7829H102.705L102.7 41.7773Z",
  fill: "#273950"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M96.1245 35.2083C96.1472 35.6149 96.3234 36.0047 96.6189 36.2871C97.3123 36.9762 97.9772 37.6483 98.6818 38.3205C99.3865 38.9927 100.233 38.9701 100.819 38.3883C101.404 37.8065 101.393 36.948 100.745 36.2702C100.04 35.5359 99.307 34.8185 98.5682 34.1181C98.3636 33.9148 98.0965 33.7792 97.8067 33.734C97.5168 33.6889 97.2213 33.734 96.9656 33.8696C96.7099 33.9826 96.4882 34.1746 96.3405 34.4118C96.1927 34.6491 96.1188 34.9258 96.1302 35.2083H96.1245Z",
  fill: "#273950"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M99.8299 40.2693C99.614 40.2693 99.4037 40.3088 99.2048 40.3935C99.0059 40.4783 98.8297 40.6025 98.6876 40.7607C97.9943 41.4498 97.3123 42.105 96.6418 42.8054C95.9712 43.5058 95.9996 44.353 96.5849 44.9179C97.1703 45.4827 98.0114 45.4996 98.7104 44.8331C99.4094 44.1723 100.125 43.4549 100.824 42.7432C101.04 42.5343 101.188 42.2631 101.239 41.9694C101.29 41.6757 101.245 41.3707 101.109 41.0996C101.006 40.851 100.83 40.6364 100.603 40.4896C100.375 40.3427 100.108 40.2636 99.8356 40.2693H99.8299Z",
  fill: "#273950"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M102.722 37.3772C102.722 37.6483 102.808 37.9081 102.955 38.1341C103.103 38.36 103.313 38.5351 103.564 38.6481C104.081 38.874 104.655 38.874 105.081 38.4786C105.922 37.7161 106.723 36.914 107.479 36.0724C107.996 35.4906 107.922 34.8128 107.405 34.2311C106.951 33.7058 106.081 33.542 105.553 34.0164C104.638 34.8185 103.802 35.6996 102.955 36.5751C102.865 36.6824 102.791 36.8124 102.751 36.9479C102.711 37.0835 102.694 37.2303 102.711 37.3715V37.3828L102.722 37.3772Z",
  fill: "#273950"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "colorChange",
  d: "M70.4652 115.987C65.9928 115.987 61.5261 116.015 57.0538 115.981C54.1248 115.959 52.2322 113.143 53.3024 110.498C53.9445 108.917 55.364 108.005 57.2397 108.005C65.6154 108.005 73.9912 108.005 82.367 108.005C82.9303 108.005 83.4935 107.994 84.0568 108.005C86.2648 108.067 87.9715 109.773 87.9997 111.942C88.0278 114.163 86.3324 115.964 84.0737 115.981C79.5394 116.015 74.9995 115.993 70.4652 115.993V115.987ZM70.5722 111.194C66.3026 111.194 62.0331 111.194 57.7635 111.194C57.4988 111.194 57.1833 111.109 56.9806 111.223C56.6764 111.398 56.2708 111.716 56.2596 111.982C56.2539 112.242 56.6651 112.56 56.9524 112.758C57.1101 112.866 57.403 112.792 57.6339 112.792C66.2069 112.792 74.7798 112.792 83.3527 112.792C83.6174 112.792 83.9385 112.871 84.1356 112.752C84.4116 112.582 84.7609 112.265 84.7609 112.01C84.7609 111.75 84.4285 111.404 84.1582 111.245C83.9329 111.115 83.578 111.2 83.2795 111.2C79.0437 111.2 74.8079 111.2 70.5722 111.2V111.194Z",
  fill: "primary"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "customFillElement",
  d: "M100 68.9468C100.028 85.4831 86.6281 98.9502 70.1098 98.9999C53.5066 99.0495 40.0142 85.6319 40 69.046C39.9788 52.4459 53.4144 38.9929 70.0106 39C86.5572 39 99.9716 52.4034 100 68.9468V68.9468ZM43.9967 68.9468C43.9755 83.2929 55.597 94.9668 69.9185 94.9951C84.2754 95.0235 95.9537 83.4205 95.9962 69.1027C96.0387 54.7424 84.4455 43.0402 70.1311 43.0047C55.7033 42.9622 44.0109 54.5652 43.9896 68.9539L43.9967 68.9468Z",
  fill: "#273950"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M67.6576 77.75L82.5 63.1663L79.5315 60.25L67.6576 71.9174L61.7185 66.0826L58.75 68.999L67.6576 77.75Z",
  fill: "#3F851E",
  className: "colorChange"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_346_650",
  x: 2,
  y: 2,
  width: 136,
  height: 136,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_346_650"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_346_650",
  result: "shape"
})));

var SvgAllTasksDone = function SvgAllTasksDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAllTasksDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/allTasksDone.e9022b0f.svg";
export { ForwardRef as ReactComponent };